export const BadgeIcon = ({
  children,
  className,
  ...props
}: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg aria-hidden="true"
      className={className}
      {...props}
    >
      {children}
      <use href="#badge" />
    </svg>
  );
};
